import styled, { css } from 'styled-components';
import { flexCenter } from '../../mixins/style-mixins.js';
import '../../mixins/scrollbar.js';
import '../../mixins/cursor.js';
import '../../mixins/font.js';
import COLORS from '../../constants/colors.js';
import '../../constants/fonts.js';
import { Breakpoint } from '../../constants/breakpoint.js';
import '../../constants/theme.js';
import '../../constants/files.js';
import '../../constants/color-variant.js';
import '../../constants/zIndexList.js';
import { isValidValue, getSizeInPx } from '../../methods/common.js';

const getBadgeStyle = (type) => {
    switch (type) {
        case "active": {
            return {
                primary: COLORS.GREEN_600,
                secondary: COLORS.GREEN_200,
            };
        }
        case "progress": {
            return {
                primary: COLORS.ORANGE_500,
                secondary: COLORS.ORANGE_100,
            };
        }
        case "warning": {
            return {
                primary: COLORS.RED,
                secondary: COLORS.RED_100,
            };
        }
        case "info": {
            return {
                primary: COLORS.PURPLE,
                secondary: COLORS.PURPLE_LIGHT,
            };
        }
        case "default":
        default: {
            return {
                primary: COLORS.GREY_600,
                secondary: COLORS.GREY_200,
            };
        }
    }
};
const BadgeDot = styled.span `
    width: 8px;
    height: 8px;
    border-radius: 50%;
`;
const BadgeWrapper = styled.div `
    ${flexCenter}
    display: inline-flex;
    gap: 10px;
    padding: 4px 16px;

    ${({ type, onClick, fillType, borderRadius, transparent }) => {
    const { primary, secondary } = getBadgeStyle(type);
    return css `
            cursor: ${!!onClick ? "pointer" : "text"};
            border-radius: ${isValidValue(borderRadius)
        ? getSizeInPx(borderRadius)
        : "16px"};
            color: ${primary};
            background-color: ${secondary};

            ${() => {
        switch (fillType) {
            case "grey-outline":
                return css `
                            background-color: ${COLORS.WHITE};
                            border: 2px solid ${COLORS.GREY_200};
                        `;
            case "outline":
                return css `
                            background-color: ${COLORS.WHITE};
                            border: 2px solid ${primary};
                        `;
            case "filled-outline":
                return css `
                            background-color: ${secondary};
                            border: 2px solid ${primary};
                        `;
        }
    }}

            ${BadgeDot} {
                background-color: ${primary};
            }

            background-color: ${transparent ? "transparent" : ""};
        `;
}}

    @media (max-width: ${Breakpoint.mobileBreakpointMaxWidth}) {
        gap: 5px;
        padding: 2px 10px;
    }
`;

export { BadgeDot, BadgeWrapper };
//# sourceMappingURL=Badge.styles.js.map
